import _groupBy from 'lodash.groupby';

export function groupBy<T = any>(collection: T[], predicate: (item: T) => any) {
  return _groupBy(collection, predicate);
}
